import {
  startOfWeek,
  startOfMonth,
  endOfWeek,
  endOfMonth,
  differenceInCalendarWeeks,
  addWeeks,
  addDays,
} from 'date-fns';

export default function getWeekArray(date) {
  const start = startOfWeek(startOfMonth(date), { weekStartsOn: 1 });
  const end = endOfWeek(endOfMonth(date), { weekStartsOn: 1 });
  const weekDifference = differenceInCalendarWeeks(end, start, {
    weekStartsOn: 1,
  });

  const weeks = [];
  for (let weekIndex = 0; weekIndex <= weekDifference; weekIndex++) {
    const currentWeek = [];
    const dayStartOfWeek = addWeeks(start, weekIndex);

    for (let day = 0; day < 7; day++) {
      currentWeek.push(addDays(dayStartOfWeek, day));
    }

    weeks.push(currentWeek);
  }

  return weeks;
}
